import { render } from "./Thongkedoanhthu.vue?vue&type=template&id=fe2dd092&scoped=true&ts=true"
import script from "./Thongkedoanhthu.vue?vue&type=script&lang=ts"
export * from "./Thongkedoanhthu.vue?vue&type=script&lang=ts"

import "./Thongkedoanhthu.vue?vue&type=style&index=0&id=fe2dd092&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/Dashboard/Dashboard_CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2dd092"]])

export default __exports__